import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
  zoraSepolia,
} from '@ourzora/chains'
import { zeroAddress } from 'viem'
import { cleanAddress } from '../../addresses'
import { ERC20Token, PoolAddressMap } from '../../types'
import abi from './abi'

/**
 * A map of paired token symbols to network and their respective Uniswap v3 pool addresses.
 */
const UNISWAP_POOLS = {
  ['USDC']: {
    [mainnet.id]: cleanAddress('0x88e6A0c2dDD26FEEb64F039a2c41296FcB3f5640'),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xd0b53D9277642d899DF5C87A3966A349A798F224'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress('0xbC59f8F3b275AA56A90D13bAE7cCe5e6e11A3b17'),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress('0x1fb3cf6e48F1E7B10213E7b6d87D4c073C7Fdb7b'),
    [arbitrum.id]: cleanAddress('0xC6962004f452bE9203591991D15f6b388e09E8D0'),
  },
  ['ZORA']: {
    [mainnet.id]: cleanAddress(zeroAddress),
    [sepolia.id]: cleanAddress(zeroAddress),
    [base.id]: cleanAddress('0xA0Ca5bEbC42cDbf3623B1C09206Ae4e3975B0FC7'),
    [baseSepolia.id]: cleanAddress(zeroAddress),
    [zora.id]: cleanAddress(zeroAddress),
    [zoraSepolia.id]: cleanAddress(zeroAddress),
    [optimism.id]: cleanAddress(zeroAddress),
    [arbitrum.id]: cleanAddress(zeroAddress),
  },
} as const satisfies PoolAddressMap

export const WETH = {
  abi,
  address: {
    [mainnet.id]: cleanAddress('0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'),
    [sepolia.id]: cleanAddress('0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9'),
    [optimism.id]: cleanAddress('0x4200000000000000000000000000000000000006'),
    [zora.id]: cleanAddress('0x4200000000000000000000000000000000000006'),
    [base.id]: cleanAddress('0x4200000000000000000000000000000000000006'),
    [baseSepolia.id]: cleanAddress('0x4200000000000000000000000000000000000006'),
    [zoraSepolia.id]: cleanAddress('0x4200000000000000000000000000000000000006'),
    [arbitrum.id]: cleanAddress('0x82aF49447D8a07e3bd95BD0d56f35241523fBab1'),
  },
  poolAddress: UNISWAP_POOLS,
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
} as const satisfies ERC20Token
